export default from './category-list-item';



// WEBPACK FOOTER //
// ./app/components/category-list-item/index.js